module.exports = __webpack_public_path__ + "./images/793bafab386950b6254c6c760ee25f58.webp";